var _path, _path2, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgIcon = function SvgIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.653 15.878a6.195 6.195 0 100-12.39 6.195 6.195 0 000 12.39zm0-1.446a4.75 4.75 0 100-9.498 4.75 4.75 0 000 9.498z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.511 15.128a1.178 1.178 0 111.707-1.625l4.736 4.988a1.169 1.169 0 01-1.693 1.612l-4.75-4.975z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.637 3.356a1.11 1.11 0 01-.06 1.568l-8.218 7.601a1.248 1.248 0 01-1.786-.093L7.935 9.425l-4.089 3.628a1.11 1.11 0 01-1.473-1.66l4.82-4.276c.517-.46 1.31-.41 1.767.11l2.624 2.992 7.485-6.924a1.11 1.11 0 011.568.061z",
    id: "small-icon-gradient",
    fill: "url(#prefix__paint0_linear_8701_11799)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.653,
    cy: 7.988,
    r: 1.376,
    stroke: "rgb(var(--Juliet))",
    strokeWidth: 0.635
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_8701_11799",
    x1: 4.635,
    y1: 11.322,
    x2: 17.881,
    y2: 6.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#FFD74C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;